import {Component, Input, OnInit} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {fuseAnimations} from '../../../../core/animations';
import {LearningPathsService} from '../../../../core/services/learningPaths.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'learning-path-participant',
  templateUrl: './learning-path-participant.component.html',
  styleUrls: ['./learning-path-participant.component.scss'],
  animations: fuseAnimations,
  standalone: false
})
export class LearningPathParticipantComponent implements OnInit{
  @Input() participants;
  @Input() hasEvent;
  @Input() hasElearning;
  @Input() rewards;
  @Input() skills;
  @Input() title;
  @Input() id;
  displayedColumns = [ 'select', 'name' , 'organization' , 'targetGroup', 'createdAt', 'rewards', 'skills', 'deleteFromParticipant'];
  selection = new SelectionModel<any>(true , []);
  checkedUsers = [];
  selectedVal = 'hide';
  levelArray = [];
  skillArray = [];
  constructor(public dialog: MatDialog, private toastr: ToastrService, private router: Router,
              private learningPathService: LearningPathsService, private translate: TranslateService) {
  }

  ngOnInit() {
    if (this.participants.length > 0) {
      this.participants = this.participants.filter(participant => participant.frontUser);
    }
    if (!!this.hasEvent) {
      this.displayedColumns.splice(this.displayedColumns.length - 3, 0, 'event');
    }
    if (!!this.hasElearning) {
      this.displayedColumns.splice(this.displayedColumns.length - 3, 0, 'elearning');
    }
    if (!!this.rewards) {
      this.levelArray = this.rewards.map(reward => +reward.eventLevelId);
      for (let i = 0; i < this.participants.length; i++) {
        let userLevels = this.participants[i].frontUser.status.split(',').filter(Boolean).map(Number);
        this.participants[i].alreadyRewarded = this.levelArray.every(level => userLevels.includes(level));
      }
    }
    if (!!this.skills) {
      this.skillArray = this.skills.map(reward => +reward.skillId);
    }
  }

  masterToggle () {
    this.isAllSelected() ?
      this.selection.clear() :
      this.participants.forEach(row => this.selection.select(row));
    this.checkedUsers = this.selection.selected;
  }

  isAllSelected () {
    const numSelected = this.selection.selected.length;
    const numRows = this.participants.length;
    return numSelected === numRows;
  }

  checkUser (user , event) {
    if (event.checked) {
      this.checkedUsers.push(user);
    } else {
      let index = this.checkedUsers.findIndex(x => +x.id === +user.id);
      if (index !== -1) {
        this.checkedUsers.splice(index , 1);
      }
    }
  }

  deleteFromParticipant (event , participant) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' , height: 'auto',
      data: {title: 'Delete' , message: 'learning_paths.removeFromParticipantMsg'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.learningPathService.deleteParticipant(participant.id).subscribe((res) => {
          if (res) {
            let index = this.participants.findIndex(x => +x.id === +participant.id);
            if (index !== -1) {
              this.participants = this.participants.filter((pt, i) => i !== index);
            }
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('learning_paths.removeFromParticipantSuccess');
            this.toastr.success(msg , title);
          }
        });
      }
    });
  }

  rewardsParticipant(user){
    event.stopPropagation();
    if (user?.alreadyRewarded) {
      return;
    }
    let title = this.translate.instant('learning_paths.giveRewards');
    let msg = this.translate.instant('learning_paths.giveRewardsMsg');
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' , height: 'auto',
      data: {title: title , message: msg}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          userId: user.frontUserId,
          eventLevel: this.levelArray.join(','),
          title: this.title
        };
        this.learningPathService.rewardsUser(data).subscribe((res) => {
          user.alreadyRewarded = true;
        });
      }
    });
  }

  skillParticipant(user){
    event.stopPropagation();
    if (user?.alreadySkilled) {
      return;
    }
    let title = this.translate.instant('learning_paths.giveSkills');
    let msg = this.translate.instant('learning_paths.giveSkillMsg');
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' , height: 'auto',
      data: {title: title , message: msg}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          frontUserId: user.frontUserId,
          skills: this.skillArray.join(','),
          learningPathsId: this.id,
          title: this.title
        };
        this.learningPathService.skillUser(data).subscribe((res) => {
          user.alreadySkilled = true;
        });
      }
    });
  }

  openDialog (user): void {

  }

  communicationAction(event) {
    if (event.value === 'emailList') {
      this.selectedVal = event.value;
      let emails = [];
      for (let i = 0; i < this.checkedUsers.length; i++) {
        if (this.checkedUsers[i].frontUser && this.checkedUsers[i].frontUser.email) {
          emails.push(this.checkedUsers[i].frontUser.email);
        }
        if (this.checkedUsers[i].email) {
          emails.push(this.checkedUsers[i].email);
        }
      }
      if (!emails.length) {
        this.toastr.error('Ausgewählte User haben keine E-Mail' , 'Error!');
        setTimeout(() => {
          this.selectedVal = 'hide';
        }, 500);
        return;
      }
      const to = emails[0];
      emails.shift();
      const cc = '';
      const bcc = emails.join(',');
      const subject = 'Betreff der E-Mail';
      const body = 'Inhalt der E-Mail...';

      this.generateEmltlFile(to, cc, bcc, subject, body);
      setTimeout(() => {
        this.selectedVal = 'hide';
      }, 500);
      return;
    }
    if (event.value === 'mail') {
      let emails = [];
      for (let i = 0; i < this.checkedUsers.length; i++ ) {
        if (this.checkedUsers[i].frontUser && this.checkedUsers[i].frontUser.email) {
          emails.push(this.checkedUsers[i].frontUser.email);
        }
        if (this.checkedUsers[i].email) {
          emails.push(this.checkedUsers[i].email);
        }
      }
      let uniqueSet = new Set(emails);
      emails = [...uniqueSet];
      this.router.navigate(['/pages/communications'], {queryParams: {
          type: 'mail',
          subtype: 'participant',
          ids: emails.toString()
        }});
    } else {
      let ids = [];
      let guestIds = [];
      for (let i = 0; i < this.checkedUsers.length; i++ ) {
        if (this.checkedUsers[i].frontUserId) {
          ids.push(this.checkedUsers[i].frontUserId);
        }
        if (this.checkedUsers[i].guestUserId) {
          guestIds.push(this.checkedUsers[i].guestUserId);
        }
      }
      this.router.navigate(['/pages/communications'], {queryParams: {
          type: event.value,
          ids: ids.toString(),
          guestIds: guestIds.toString()
        }});
    }
  }
  generateEmltlFile(to, cc, bcc, subject, body) {
    const emlContent = `To: ${to}\r\nCc: ${cc || ''}\r\nBcc: ${bcc || ''}\r\nSubject: ${subject}\r\nX-Unsent: 1\r\nContent-Type: text/html\r\n\r\n<html><body>${body}</body></html>`;
    const blob = new Blob([emlContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'email.eml';
    a.click();

    URL.revokeObjectURL(url);
  }
}
